import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { LogoIcon } from 'components/Elements'
import { SidebarContent } from '../SidebarContent'

export const SidebarVerticalMenu = () => {
  const { t } = useTranslation()

  return (
    <div className="vertical-menu">
      <div className="navbar-brand-box">
        <Link to="/" className="logo logo-dark">
          <span className="logo-sm">
            <LogoIcon type={'icon'} />
          </span>
          <span className="logo-lg">
            <LogoIcon />
          </span>
        </Link>
      </div>
      <SidebarContent />
      <div className="sidebar-background" />
    </div>
  )
}
